/* eslint camelcase: 0, no-unused-expressions: 0 */
/* global FB */

import React from 'react';
import { BootstrapModal } from '../modal/bootstrap-modal';
import { VerificationForm } from './verification-form';

export class EmailVerifyModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      footer: null
    };
    this.showHideVerificationFooter = this.showHideVerificationFooter.bind(this);
  }

  showHideVerificationFooter () {
    this.setState({ footer: this.verificationFooter() });
  }

  verificationFooter () {
    setTimeout(() => {
      return this.setState({ footer: null });
    }, 3500);
    return (<p className="subform-text text-center text-valid">
      <i className="ico icon-yes text-green"/>&nbsp;Code Sent!
    </p>);
  }

  render () {
    const { footer } = this.state;
    return (
      <BootstrapModal
        {...this.props}
        header={
          <div>
            <h3>Verify your email</h3>
            <p className="text-small text-gray-600">Please check your email and enter the 4-digit code below to make sure your account is valid.</p>
          </div>
        }
        modalClass="email-verify-modal"
        body={
          <VerificationForm
            callbackFn={this.props.emailVerifyCb}
            verificationFooter={this.showHideVerificationFooter}
          />
        }
        footer={footer}
      />
    );
  }
}
